import { render, staticRenderFns } from "./editor-selector.vue?vue&type=template&id=1ac7a99a"
import script from "./editor-selector.vue?vue&type=script&lang=ts"
export * from "./editor-selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports